import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';

class List extends Component {
  static propTypes = {
    companies: PropTypes.array
  }

  render() {
    const { companies } = this.props;
    const content = companies.map((item, key) => {
      const { id, name } = item;
      return (<TableRow key={key}>
        <TableRowColumn>{id}</TableRowColumn>
        <TableRowColumn>{name}</TableRowColumn>
      </TableRow>);
    });

    return (
      <div>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHeaderColumn>ID</TableHeaderColumn>
              <TableHeaderColumn>Name</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody>
            { content }
          </TableBody>
        </Table>
      </div>
    );
  }
}

export default List;


// WEBPACK FOOTER //
// ./src/components/Companies/List.js